import { SxProperties } from '@bvi/mui-theme';

export const styles = {
  wrapper: {
    marginTop: '16px',
  },
  table: {
    minWidth: 640,
  },
  headerCell: {
    color: 'text.secondary',
    fontWeight: 500,
    fontSize: '13px',
    backgroundColor: 'transparent',
    whiteSpace: 'nowrap',
  },
  bodyCell: {
    fontFamily: 'Lato',
    fontSize: '14px',
    whiteSpace: 'nowrap',
  },
  titleSkeleton: {
    minWidth: '220px',
    height: '28px',
  },
  tableSkeleton: {
    minHeight: '120px',
    width: '100%',
  },
} satisfies SxProperties;
